function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var _excluded = ["image_base64"];
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Container, Divider, Stack, Typography, Link } from '@mui/material';
import { constants, ROUTES } from '../constants';
import { useNavigate } from 'react-router-dom';
import { ConfigContext, useSettingsData, usePageImage, useHeaderImage } from '../components/ConfigContext';
import { AuthorizationAPI } from '../apis';
import { handleErrorModal } from '../components/Toast';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import { decodeAccessToken } from '../utils/auth';
import { normalizeEmail, getSelectedLanguageFromCookie } from '../utils/utilities';
import { useApplicationsList } from '../components/ApplicationContext';
import { usePoliciesData } from '../components/PoliciesContext';
import { useTranslation } from 'react-i18next';
var Home = function Home() {
    var _useTranslation = useTranslation(), i18n = _useTranslation.i18n;
    var router = useNavigate();
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isLogin = _useState2[0], setIsLogin = _useState2[1];
    var loginURL = process.env.REACT_APP_API_URL + '/authentication/loginRedirect';
    var _useContext = useContext(ConfigContext), configState = _useContext.configState, setConfigState = _useContext.setConfigState;
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), loader = _useState4[0], setLoader = _useState4[1];
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), firstProduct = _useState6[0], setFirstProduct = _useState6[1];
    var getApplications = useApplicationsList();
    // Cached data hooks
    var getCachedSettings = useSettingsData();
    var getCachedPageImage = usePageImage();
    var getCachedHeaderImage = useHeaderImage();
    var getCachedPolicies = usePoliciesData();
    // Load applications only after getting the token (when user is authenticated)
    var loadProducts = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var apps, applications, products, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            _context.p = 0;
                            _context.n = 1;
                            return getApplications();
                        case 1:
                            apps = _context.v;
                            applications = apps; // Filter out RBAC application and get products with productName
                            products = applications.filter(function (app) {
                                var _app$details;
                                return (app === null || app === void 0 || (_app$details = app.details) === null || _app$details === void 0 ? void 0 : _app$details.productName) && app.name !== 'RBAC';
                            });
                            if (products.length > 0) {
                                setFirstProduct(products[0]);
                            }
                            _context.n = 3;
                            break;
                        case 2:
                            _context.p = 2;
                            _t = _context.v;
                            console.error('Error loading applications:', _t);
                            // Fallback: if products can't be loaded, redirect to /apps or show error
                            setFirstProduct(null);
                        case 3:
                            return _context.a(2);
                    }
            }, _callee, null, [[0, 2]]);
        }));
        return function loadProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function () {
        var fetchData = /*#__PURE__*/ function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
                var _t2;
                return _regenerator().w(function (_context2) {
                    while (1)
                        switch (_context2.p = _context2.n) {
                            case 0:
                                _context2.p = 0;
                                _context2.n = 1;
                                return Promise.all([getSettings(), getPageImage(), getHeaderImage()]);
                            case 1:
                                setClientColorInCookie();
                                _context2.n = 3;
                                break;
                            case 2:
                                _context2.p = 2;
                                _t2 = _context2.v;
                                console.error('Failed to load initial settings:', _t2);
                            case 3:
                                return _context2.a(2);
                        }
                }, _callee2, null, [[0, 2]]);
            }));
            return function fetchData() {
                return _ref2.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var setClientColorInCookie = function setClientColorInCookie() {
        var _configState$settings;
        var themeColor = {
            color: (configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color) || '#26890D'
        };
        Cookies.set('theme', JSON.stringify(themeColor), {
            secure: true,
            sameSite: 'Strict'
        });
    };
    var getSettings = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var response;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return getCachedSettings();
                        case 1:
                            response = _context3.v;
                            setConfigState(function (prevState) {
                                return _objectSpread(_objectSpread({}, prevState), {}, {
                                    settings: _objectSpread(_objectSpread({}, prevState.settings), response)
                                });
                            });
                        case 2:
                            return _context3.a(2);
                    }
            }, _callee3);
        }));
        return function getSettings() {
            return _ref3.apply(this, arguments);
        };
    }();
    var getPageImage = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var response;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            _context4.n = 1;
                            return getCachedPageImage();
                        case 1:
                            response = _context4.v;
                            setConfigState(function (prevState) {
                                return _objectSpread(_objectSpread({}, prevState), {}, {
                                    settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                        page_image: response
                                    })
                                });
                            });
                        case 2:
                            return _context4.a(2);
                    }
            }, _callee4);
        }));
        return function getPageImage() {
            return _ref4.apply(this, arguments);
        };
    }();
    var getHeaderImage = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var response;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.n) {
                        case 0:
                            _context5.n = 1;
                            return getCachedHeaderImage();
                        case 1:
                            response = _context5.v;
                            setConfigState(function (prevState) {
                                return _objectSpread(_objectSpread({}, prevState), {}, {
                                    settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                        header_logo_image: response
                                    })
                                });
                            });
                        case 2:
                            return _context5.a(2);
                    }
            }, _callee5);
        }));
        return function getHeaderImage() {
            return _ref5.apply(this, arguments);
        };
    }();
    useEffect(function () {
        if (isLogin) {
            var _process$env$REACT_AP;
            globalThis.window.dispatchEvent(new Event('userAvailable'));
            if (JSON.parse((_process$env$REACT_AP = process.env.REACT_APP_true) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'false')) {
                // Redirect to product selection page
                router(ROUTES.APPS);
            }
            else {
                var _firstProduct$details, _firstProduct$details2, _firstProduct$details3, _firstProduct$details4, _firstProduct$details5, _firstProduct$details6;
                // Redirect to first product from database
                var temp = structuredClone(configState);
                temp.selectedProduct = (_firstProduct$details = firstProduct === null || firstProduct === void 0 || (_firstProduct$details2 = firstProduct.details) === null || _firstProduct$details2 === void 0 ? void 0 : _firstProduct$details2.productName) !== null && _firstProduct$details !== void 0 ? _firstProduct$details : '';
                setConfigState(temp);
                Cookies.set('Product Selected', (_firstProduct$details3 = firstProduct === null || firstProduct === void 0 || (_firstProduct$details4 = firstProduct.details) === null || _firstProduct$details4 === void 0 ? void 0 : _firstProduct$details4.productName) !== null && _firstProduct$details3 !== void 0 ? _firstProduct$details3 : '', {
                    secure: true,
                    sameSite: 'Strict'
                });
                if (firstProduct) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    var _ref6 = firstProduct.details || {}, image_base64 = _ref6.image_base64, detailsWithoutImage = _objectWithoutProperties(_ref6, _excluded);
                    var appToStore = _objectSpread(_objectSpread({}, firstProduct), {}, {
                        details: detailsWithoutImage
                    });
                    sessionStorage.setItem('current_application', JSON.stringify(appToStore));
                }
                router("/".concat((_firstProduct$details5 = firstProduct === null || firstProduct === void 0 || (_firstProduct$details6 = firstProduct.details) === null || _firstProduct$details6 === void 0 ? void 0 : _firstProduct$details6.productName) !== null && _firstProduct$details5 !== void 0 ? _firstProduct$details5 : ''));
            }
        }
        else {
            getToken();
        }
    }, [isLogin, firstProduct]);
    function getToken() {
        return _getToken.apply(this, arguments);
    }
    function _getToken() {
        _getToken = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee9() {
            return _regenerator().w(function (_context9) {
                while (1)
                    switch (_context9.n) {
                        case 0:
                            setLoader(true);
                            _context9.n = 1;
                            return AuthorizationAPI.getToken().then(/*#__PURE__*/ function () {
                                var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee8(result) {
                                    return _regenerator().w(function (_context8) {
                                        while (1)
                                            switch (_context8.n) {
                                                case 0:
                                                    if (!(result !== null && result !== void 0 && result.accessToken)) {
                                                        _context8.n = 2;
                                                        break;
                                                    }
                                                    Cookies.set('access_token', result.accessToken, {
                                                        secure: true,
                                                        sameSite: 'Strict'
                                                    });
                                                    Cookies.set('refresh_token', result.refreshToken, {
                                                        secure: true,
                                                        sameSite: 'Strict'
                                                    });
                                                    Cookies.set('ui_trace_id', uuidv4().replaceAll('-', ''), {
                                                        secure: true,
                                                        sameSite: 'Strict'
                                                    });
                                                    // Load products after authentication
                                                    _context8.n = 1;
                                                    return loadProducts();
                                                case 1:
                                                    getUser();
                                                    _context8.n = 3;
                                                    break;
                                                case 2:
                                                    setLoader(false);
                                                case 3:
                                                    return _context8.a(2);
                                            }
                                    }, _callee8);
                                }));
                                return function (_x) {
                                    return _ref9.apply(this, arguments);
                                };
                            }())["catch"](function () {
                                setLoader(false);
                            });
                        case 1:
                            return _context9.a(2);
                    }
            }, _callee9);
        }));
        return _getToken.apply(this, arguments);
    }
    var getUser = /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6() {
            var userName;
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.n) {
                        case 0:
                            setLoader(true);
                            if (Cookies.get('access_token')) {
                                _context6.n = 1;
                                break;
                            }
                            setLoader(false);
                            handleErrorModal(true, constants.home_error_access_token_not_found);
                            return _context6.a(2);
                        case 1:
                            userName = normalizeEmail(decodeAccessToken(Cookies.get('access_token')));
                            if (userName) {
                                _context6.n = 2;
                                break;
                            }
                            setLoader(false);
                            handleErrorModal(true, constants.home_error_user_name_not_found);
                            return _context6.a(2);
                        case 2:
                            _context6.n = 3;
                            return AuthorizationAPI.getUser(userName).then(function (response) {
                                var _firstProduct$details7, _firstProduct$details8;
                                var user = response.resource.find(function (item) {
                                    return item.username === userName;
                                });
                                Cookies.set('user', JSON.stringify(user), {
                                    secure: true,
                                    sameSite: 'Strict'
                                });
                                // Sync language after cookie is set
                                var userLanguage = getSelectedLanguageFromCookie();
                                if (userLanguage && i18n.language !== userLanguage) {
                                    i18n.changeLanguage(userLanguage);
                                }
                                setConfigState(_objectSpread(_objectSpread({}, configState), {}, {
                                    selectedProduct: (_firstProduct$details7 = firstProduct === null || firstProduct === void 0 || (_firstProduct$details8 = firstProduct.details) === null || _firstProduct$details8 === void 0 ? void 0 : _firstProduct$details8.productName) !== null && _firstProduct$details7 !== void 0 ? _firstProduct$details7 : ''
                                }));
                                getPolicy();
                            })["catch"](function () {
                                setLoader(false);
                            });
                        case 3:
                            return _context6.a(2);
                    }
            }, _callee6);
        }));
        return function getUser() {
            return _ref7.apply(this, arguments);
        };
    }();
    var RedirectToLogin = function RedirectToLogin() {
        var _globalThis$window;
        (_globalThis$window = globalThis.window) === null || _globalThis$window === void 0 || _globalThis$window.location.replace(loginURL);
    };
    var getPolicy = /*#__PURE__*/ function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7() {
            var _t3;
            return _regenerator().w(function (_context7) {
                while (1)
                    switch (_context7.p = _context7.n) {
                        case 0:
                            setLoader(true);
                            _context7.p = 1;
                            _context7.n = 2;
                            return getCachedPolicies();
                        case 2:
                            _context7.n = 4;
                            break;
                        case 3:
                            _context7.p = 3;
                            _t3 = _context7.v;
                            console.error('Failed to load policies:', _t3);
                        case 4:
                            setIsLogin(true);
                            setLoader(false);
                        case 5:
                            return _context7.a(2);
                    }
            }, _callee7, null, [[1, 3]]);
        }));
        return function getPolicy() {
            return _ref8.apply(this, arguments);
        };
    }();
    var getCookiePrivacyButtons = function getCookiePrivacyButtons() {
        var isNewDesign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var textColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#FFFFFF';
        return /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            spacing: 2.5,
            sx: {
                mt: 3,
                alignItems: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Link, {
            href: process.env.REACT_APP_https://cookienotice.deloitte.com,
            target: "_blank",
            rel: "noopener noreferrer",
            underline: "none",
            sx: _objectSpread({
                color: textColor
            }, isNewDesign && {
                fontFamily: 'Open Sans',
                fontSize: '16px',
                fontWeight: 400,
                textTransform: 'none',
                mr: 3
            })
        }, constants.privacy), /*#__PURE__*/ React.createElement(Divider, {
            orientation: "vertical",
            sx: {
                border: "1px solid ".concat(textColor),
                height: '20px',
                mt: '7px !important'
            },
            flexItem: true
        }), /*#__PURE__*/ React.createElement(Link, {
            href: process.env.REACT_APP_https://www2.deloitte.com/us/en/footerlinks1/privacy.html,
            target: "_blank",
            rel: "noopener noreferrer",
            underline: "none",
            sx: _objectSpread({
                color: textColor
            }, isNewDesign && {
                fontFamily: 'Open Sans',
                fontSize: '16px',
                fontWeight: 400,
                textTransform: 'none'
            })
        }, constants.cookies));
    };
    var getDefaultLoginPage = function getDefaultLoginPage() {
        var _configState$settings2, _configState$settings3, _configState$settings4, _configState$settings5, _configState$settings6, _configState$settings7, _configState$settings8, _configState$settings9, _configState$settings0, _configState$settings1, _configState$settings10, _configState$settings11, _configState$settings12, _configState$settings13, _configState$settings14, _configState$settings15, _configState$settings16, _configState$settings17, _configState$settings18;
        return /*#__PURE__*/ React.createElement(Container, {
            disableGutters: true,
            maxWidth: false,
            sx: {
                height: '100vh',
                width: '100%',
                maxWidth: '100%',
                maxHeight: '100vh',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: {
                    xs: 'flex',
                    sm: 'grid'
                },
                flexDirection: {
                    xs: 'column',
                    sm: 'unset'
                },
                justifyContent: {
                    xs: 'center',
                    sm: 'unset'
                },
                alignItems: {
                    xs: 'center',
                    sm: 'unset'
                },
                gridTemplateColumns: {
                    sm: '1fr 1fr'
                },
                height: '100%',
                width: '100%',
                overflow: 'hidden'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: '100%',
                minWidth: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: {
                    xs: '100%',
                    md: 'auto'
                },
                textAlign: 'center',
                px: {
                    xs: 2,
                    md: 0
                }
            }
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "column",
            sx: {
                width: {
                    xs: '90%',
                    md: '70%'
                },
                alignItems: 'center',
                textAlign: 'center'
            }
        }, (configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.show_logo) && /*#__PURE__*/ React.createElement(Box, {
            component: "img",
            src: (_configState$settings3 = configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.header_logo_image) !== null && _configState$settings3 !== void 0 ? _configState$settings3 : '',
            alt: constants.home_header_logo_alt,
            sx: {
                objectFit: 'contain',
                height: '50px'
            }
        }), (configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.show_logo) && (configState === null || configState === void 0 || (_configState$settings6 = configState.settings) === null || _configState$settings6 === void 0 ? void 0 : _configState$settings6.industry_name) && /*#__PURE__*/ React.createElement(Box, {
            sx: {
                backgroundColor: '#000000',
                color: '#FFFFFF',
                borderRadius: '16px',
                padding: '4px 16px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '12px'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontFamily: 'Open Sans',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: 1.5,
                color: 'inherit'
            }
        }, "for ".concat(configState.settings.industry_name))), (configState === null || configState === void 0 || (_configState$settings7 = configState.settings) === null || _configState$settings7 === void 0 ? void 0 : _configState$settings7.show_workspace_name) && /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            sx: {
                marginTop: configState !== null && configState !== void 0 && (_configState$settings8 = configState.settings) !== null && _configState$settings8 !== void 0 && _configState$settings8.show_logo ? '24px' : '0px',
                fontSize: '26px'
            },
            color: configState === null || configState === void 0 || (_configState$settings9 = configState.settings) === null || _configState$settings9 === void 0 ? void 0 : _configState$settings9.welcome_message_color,
            fontWeight: 700,
            dangerouslySetInnerHTML: {
                __html: (_configState$settings0 = configState === null || configState === void 0 || (_configState$settings1 = configState.settings) === null || _configState$settings1 === void 0 ? void 0 : _configState$settings1.workspace_name) !== null && _configState$settings0 !== void 0 ? _configState$settings0 : ''
            }
        }), /*#__PURE__*/ React.createElement(Button, {
            variant: "contained",
            size: "large",
            disabled: loader,
            sx: {
                marginTop: '16px',
                textTransform: 'none',
                borderColor: "1px solid ".concat(configState === null || configState === void 0 || (_configState$settings10 = configState.settings) === null || _configState$settings10 === void 0 ? void 0 : _configState$settings10.button_color, " !important"),
                backgroundColor: "".concat(configState === null || configState === void 0 || (_configState$settings11 = configState.settings) === null || _configState$settings11 === void 0 ? void 0 : _configState$settings11.button_color, " !important"),
                color: "".concat(configState === null || configState === void 0 || (_configState$settings12 = configState.settings) === null || _configState$settings12 === void 0 ? void 0 : _configState$settings12.button_text_color, " !important"),
                '&:hover': {
                    backgroundColor: configState === null || configState === void 0 || (_configState$settings13 = configState.settings) === null || _configState$settings13 === void 0 ? void 0 : _configState$settings13.button_color,
                    borderColor: configState === null || configState === void 0 || (_configState$settings14 = configState.settings) === null || _configState$settings14 === void 0 ? void 0 : _configState$settings14.button_color,
                    color: "".concat(configState === null || configState === void 0 || (_configState$settings15 = configState.settings) === null || _configState$settings15 === void 0 ? void 0 : _configState$settings15.button_text_color, " !important")
                },
                '&:disabled': {
                    backgroundColor: "".concat(configState === null || configState === void 0 || (_configState$settings16 = configState.settings) === null || _configState$settings16 === void 0 ? void 0 : _configState$settings16.button_color, " !important"),
                    color: "".concat(configState === null || configState === void 0 || (_configState$settings17 = configState.settings) === null || _configState$settings17 === void 0 ? void 0 : _configState$settings17.button_text_color, " !important"),
                    opacity: 0.7
                }
            },
            onClick: function onClick(e) {
                e.preventDefault();
                e.stopPropagation();
                setLoader(true);
                RedirectToLogin();
            },
            "data-testid": "login_button",
            startIcon: loader ? /*#__PURE__*/ React.createElement(CircularProgress, {
                size: 20,
                color: "inherit"
            }) : null
        }, loader ? /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                color: 'inherit',
                fontFamily: 'Roboto',
                fontSize: 15,
                fontWeight: 600,
                letterSpacing: 0.46
            }
        }, constants.loading) : /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            fontWeight: 700
        }, constants.Login_button)), getCookiePrivacyButtons(true, '#595959'))), (configState === null || configState === void 0 || (_configState$settings18 = configState.settings) === null || _configState$settings18 === void 0 ? void 0 : _configState$settings18.page_image) && /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: {
                    xs: 'none',
                    sm: 'flex'
                },
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                minWidth: 0
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            component: "img",
            src: configState.settings.page_image,
            alt: constants.home_page_image_alt,
            sx: {
                height: '100%',
                width: '100%',
                maxHeight: '100vh',
                objectFit: 'cover',
                objectPosition: 'center',
                display: 'block'
            }
        }))));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, getDefaultLoginPage());
};
export default Home;
